module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.startSearch.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "usercode",
      "label": "UserCode",
      "min-width": "150",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "icoon",
          attrs: {
            "src": "./static/" + scope.row.useravatar
          }
        }), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin": "7px 40px"
          }
        }, [_vm._v(_vm._s(scope.row.usercode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "Name",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useremail",
      "label": "Email",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userroles",
      "label": "Role(s)",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "departments",
      "label": "Depts",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stages",
      "label": "Stages",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "150px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" User")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UserCode:",
      "prop": "usercode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['usercode']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usercode', $$v)
      },
      expression: "editForm['usercode']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Role(s) :",
      "prop": "uroles"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select User Role(s)"
    },
    model: {
      value: (_vm.uroles),
      callback: function($$v) {
        _vm.uroles = $$v
      },
      expression: "uroles"
    }
  }, _vm._l((_vm.codes.roles), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Department(s) :",
      "prop": "udepts"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select Department(s)"
    },
    model: {
      value: (_vm.udepts),
      callback: function($$v) {
        _vm.udepts = $$v
      },
      expression: "udepts"
    }
  }, _vm._l((_vm.codes.depts), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Allowed Stage(s) :",
      "prop": "ustages"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select Allowed Stages"
    },
    model: {
      value: (_vm.ustages),
      callback: function($$v) {
        _vm.ustages = $$v
      },
      expression: "ustages"
    }
  }, _vm._l((_vm.stageList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name :",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['username']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'username', $$v)
      },
      expression: "editForm['username']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email :",
      "prop": "useremail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['useremail']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'useremail', $$v)
      },
      expression: "editForm['useremail']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "New Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['password']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'password', $$v)
      },
      expression: "editForm['password']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Avatar :"
    }
  }, [_c('img', {
    staticClass: "icoon",
    attrs: {
      "src": _vm.curIcon
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "autocomplete": "",
      "filterable": "",
      "value-key": "editForm.userImg",
      "placeholder": "Select Icon"
    },
    on: {
      "change": _vm.showChanged
    },
    model: {
      value: (_vm.editForm.useravatar),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "useravatar", $$v)
      },
      expression: "editForm.useravatar"
    }
  }, _vm._l((_vm.codes.Img), function(item) {
    return _c('el-option', {
      key: item.code,
      staticStyle: {
        "height": "45px"
      },
      attrs: {
        "label": item.desc,
        "value": item.value
      }
    }, [_c('img', {
      staticClass: "icoon",
      attrs: {
        "src": './static/' + item.value
      }
    }), _c('span', {
      staticStyle: {
        "margin": "5px 10px",
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.desc))])])
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "5px",
      "line-height": "14px",
      "font-size": "10px",
      "float": "right"
    },
    attrs: {
      "title": _vm.editForm['_udet']
    }
  }, [_vm._v("\n            Hash: " + _vm._s(_vm.editForm['pwdhash'])), _c('br'), _vm._v("\n            Pwd Modified: " + _vm._s(_vm.editForm['pwdmodified']) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UserToken :",
      "prop": "usertoken"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "width": "10",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['usertoken']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usertoken', $$v)
      },
      expression: "editForm['usertoken']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.editForm['usertokenDel'] != true) ? _c('span', [_c('el-switch', {
    attrs: {
      "width": 40,
      "xactive-color": "green",
      "active-color": "#58a632",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['usertokenGen']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usertokenGen', $$v)
      },
      expression: "editForm['usertokenGen']"
    }
  }), _vm._v("       Generate        \n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.editForm['usertoken'] != '' && _vm.editForm['usertokenGen'] != true) ? _c('span', [_c('el-switch', {
    attrs: {
      "width": 40,
      "active-color": "red",
      "xactive-color": "#58a632",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['usertokenDel']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'usertokenDel', $$v)
      },
      expression: "editForm['usertokenDel']"
    }
  }), _vm._v("          Clear\n            ")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n          Reset PWD:   \n          "), _c('el-switch', {
    attrs: {
      "active-color": "#409EFF",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['pwdreset']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'pwdreset', $$v)
      },
      expression: "editForm['pwdreset']"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b358b1b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/xuser.vue
// module id = 651
// module chunks = 1